// extracted by mini-css-extract-plugin
export default {"json":"JsonDisplay_json__HL389"};